import setGrabCursor from './setGrabCursor.js';
import unsetGrabCursor from './unsetGrabCursor.js';

export defa mx-1  ult {
  setGrabCursor,
  unsetGrabCursor,
};
